<template>
    <v-dialog
      v-model="show"
      @click:outside="closeModal"
      width="500"
    >
      <v-card>
        <v-card-title 
            class="text-h5 white--text"
            style="background-color:#5087e6;"
        >
          新增容器
        </v-card-title>

        <v-card-text>
            <v-form ref="form" class="mx-2" lazy-validation>
                <v-container>
                    <v-row align="center">
                        <v-col
                            md="12"
                        >
                            <h4
                            >
                                容器名稱:
                            </h4>
                            <v-text-field
                                :success="!!container_name"
                                v-model="container_name"
                                :rules="[rules.required]"
                                outlined
                                height="12"
                                dense
                                hint="範例: 我的商店"
                                validate-on-blur
                            ></v-text-field>
                        </v-col>

                    </v-row>

                    <v-row align="center">
                        <v-col
                            md="12"
                        >
                            <h4
                            >
                                容器網站:
                            </h4>
                            <v-text-field
                                :success="!!container_domain"
                                v-model="container_domain"
                                outlined
                                height="12"
                                dense
                                hint="範例: www.example.com"
                                validate-on-blur
                                :rules="[rules.validateHost, rules.required]"
                            ></v-text-field>
                        </v-col>

                    </v-row>
                </v-container>
            </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeModal"
          >
            取消
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="addContainer"
          >
            新增
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'ContainerNew',
    components: {
    },
    data: function(){
      return {

        container_name: '',
        container_domain: '',
        btn: {
          "view": "檢視"
        },
        show: true,
        rules: this.$utils.field_rules,

      }
    }, 
    created: async function(){
    },
    mounted: function(){
        console.log('yo Dialog')
    },
    methods: {
        addContainer: function(){
            let result = this.$refs.form.validate();

            if (!result) {
                return
            }

            console.log(result)
            this.$emit('send',{
              name: this.container_name,
              domain: this.container_domain,
            })
        },
        closeModal: function(){
            this.$emit('close',false)
        }
    },
    watch: {
    },
    computed: {
    }     
  }
</script>
<style scoped>
h4 {
    color: #5b5b5b;
}
</style>